import Payment from "src/components/feature/Payment";

const DefaultPayment = () => {
  return <Payment />;
};

export default DefaultPayment;
